import { useState } from 'react';
import { ReactComponent as NotificationBellIcon } from 'src/assets/tailwind/Notifications/notification-icon.svg';
import { Button } from 'src/components/ui/button';
import { Icon } from 'src/components/ui/icon';
import { Popover, PopoverContent, PopoverTrigger } from 'src/components/ui/popover';
import { cn } from 'src/utils/utils';

import type { NotificationsPopoverProps } from '../types';
import useNotifications from '../hooks/useNotifications';
import { NOTIFICATIONS_PANEL_OFFSET } from '../constants';
import NotificationsPanel from './NotificationsPanel';

const NotificationsPopover = ({ className }: NotificationsPopoverProps) => {
  const [open, setOpen] = useState(false);

  const {
    activeTab,
    setActiveTab,
    notifications,
    totalCount,
    unreadCount,
    hasMore,
    isLoading,
    handleLoadMore,
    handleMarkAllAsRead,
    handleDismissAll,
    handleDismiss,
    handleMarkReadStatus
  } = useNotifications({ open });

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          iconOnly
          category="rounded"
          hierarchy="ghost"
          active={open}
          className={cn('tw:shrink-0', className)}
          aria-label="Open notifications"
          leftComp={
            <span className="tw:pointer-events-none tw:relative tw:inline-flex">
              <Icon
                icon={NotificationBellIcon}
                sizeClass="tw:h-l tw:w-l tw:text-icon-primary"
              />
              {unreadCount > 0 && (
                <span
                  className="tw:absolute tw:-right-0.5 tw:-top-0.5 tw:h-s tw:w-s tw:rounded-full tw:bg-brand tw:ring-2 tw:ring-primary"
                  aria-hidden
                />
              )}
            </span>
          }
        />
      </PopoverTrigger>
      <PopoverContent
        side="right"
        align="end"
        sideOffset={NOTIFICATIONS_PANEL_OFFSET}
        className="tw:p-0"
      >
        <NotificationsPanel
          notifications={notifications}
          activeTab={activeTab}
          onTabChange={setActiveTab}
          onClose={() => setOpen(false)}
          onMarkAllAsRead={handleMarkAllAsRead}
          onDismissAll={handleDismissAll}
          onDismiss={handleDismiss}
          onMarkReadStatus={handleMarkReadStatus}
          onLoadMore={handleLoadMore}
          hasMore={hasMore}
          isLoading={isLoading}
          totalCount={totalCount}
          unreadCount={unreadCount}
        />
      </PopoverContent>
    </Popover>
  );
};

export default NotificationsPopover;
